import { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

class ShowForceAutoriskClassReductionComponent extends Component {
  render() {
    const {
      forceAutoRiskClassReduction,
      selectedLabelHasAutoRiskClassReduction,
      interestPayment,
      totalInterestPaymentWithoutForceAutoRiskClassReduction,
    } = this.props;

    let component = <td>{interestPayment}</td>;

    /* Possible saving */
    const saving = numeral(totalInterestPaymentWithoutForceAutoRiskClassReduction - numeral(interestPayment)
      .value()).format('$ 0,00.00');

    if (forceAutoRiskClassReduction && !selectedLabelHasAutoRiskClassReduction) {
      component = (
        <td colSpan={3}>
          <div className={'calculation-container__loanpart-overview__reduction-container'}>
            <div>
              <div className={'calculation-container__loanpart-overview__title'}>
                Totale rentelast met looptijdrente:
              </div>
              <div className={'calculation-container__loanpart-overview__amount'}>
                {interestPayment}
              </div>
            </div>
            <div>
              <div className={'calculation-container__loanpart-overview__title'}>
                Totale rentelast zonder looptijdrente:
              </div>
              <div
                className={`calculation-container__loanpart-overview__amount
                  calculation-container__loanpart-overview__amount-with-border`}
              >
                {numeral(totalInterestPaymentWithoutForceAutoRiskClassReduction).format('$ 0,00.00')}
              </div>
            </div>
            <div className={'calculation-container__loanpart-overview__reduction-reduction-row'}>
              <div className={'calculation-container__loanpart-overview__title'}>
                Mogelijke besparing:
              </div>
              <div className={'calculation-container__loanpart-overview__reduction-amount'}>
                {saving}
              </div>
            </div>
          </div>
        </td>
      );
    }
    return component;
  }
}

ShowForceAutoriskClassReductionComponent.propTypes = {
  interestPayment: PropTypes.string,
  totalInterestPaymentWithoutForceAutoRiskClassReduction: PropTypes.number,
  forceAutoRiskClassReduction: PropTypes.bool,
  selectedLabelHasAutoRiskClassReduction: PropTypes.bool,
};

ShowForceAutoriskClassReductionComponent.defaultProps = {
  interestPayment: '',
  totalInterestPaymentWithoutForceAutoRiskClassReduction: 0,
  forceAutoRiskClassReduction: false,
  selectedLabelHasAutoRiskClassReduction: false,
};

export default ShowForceAutoriskClassReductionComponent;
